import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './OfferEditing.css';

const OfferEditing = () => {
  const [sections, setSections] = useState({
    HomeSpecialVeg: { heading: '', subheading: '', bannerImage: '', category: '' },
    HomeVegetableSlider: { heading: '', subheading: '', bannerImage: '', category: '' },
    SalesOfTheDay: { heading: '', subheading: '', bannerImage: '', category: '' },
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchSectionContent = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/admin/section-content`);
        const contentMap = response.data.reduce((acc, item) => {
          acc[item.sectionName] = item;
          return acc;
        }, {});
        setSections({
          HomeSpecialVeg: contentMap.HomeSpecialVeg || { heading: '', subheading: '', bannerImage: '', category: '' },
          HomeVegetableSlider: contentMap.HomeVegetableSlider || { heading: '', subheading: '', bannerImage: '', category: '' },
          SalesOfTheDay: contentMap.SalesOfTheDay || { heading: '', subheading: '', bannerImage: '', category: '' },
        });
        setLoading(false);
      } catch (err) {
        setError('Failed to load section content');
        setLoading(false);
      }
    };
    fetchSectionContent();
  }, [API_BASE_URL]);

  const handleChange = (section, field, value) => {
    setSections((prev) => ({
      ...prev,
      [section]: { ...prev[section], [field]: value },
    }));
  };

  const handleSave = async (sectionName) => {
    try {
      const { heading, subheading, bannerImage, category } = sections[sectionName];
      await axios.put(`${API_BASE_URL}/api/admin/section-content/${sectionName}`, {
        heading,
        subheading,
        bannerImage,
        category,
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setError('Section updated successfully');
      setTimeout(() => setError(''), 3000);
    } catch (err) {
      setError('Failed to update section content');
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error && !error.includes('successfully')) return <div>{error}</div>;

  return (
    <div className="offer-editing-container">
      <h1>Offer Content Editing</h1>
      {error.includes('successfully') && <div className="success-message">{error}</div>}
      {Object.keys(sections).map((section) => (
        <div key={section} className="section-edit-form">
          <h2>{section} Settings</h2>
          <div className="form-group">
            <label>Heading:</label>
            <input
              type="text"
              value={sections[section].heading}
              onChange={(e) => handleChange(section, 'heading', e.target.value)}
              placeholder="Enter heading"
            />
          </div>
          <div className="form-group">
            <label>Subheading:</label>
            <input
              type="text"
              value={sections[section].subheading}
              onChange={(e) => handleChange(section, 'subheading', e.target.value)}
              placeholder="Enter subheading"
            />
          </div>
          <div className="form-group">
            <label>Banner Image URL:</label>
            <input
              type="text"
              value={sections[section].bannerImage}
              onChange={(e) => handleChange(section, 'bannerImage', e.target.value)}
              placeholder="Enter banner image URL"
            />
          </div>
          <div className="form-group">
            <label>Category:</label>
            <input
              type="text"
              value={sections[section].category}
              onChange={(e) => handleChange(section, 'category', e.target.value)}
              placeholder="Enter category"
            />
          </div>
          <button onClick={() => handleSave(section)}>Save {section}</button>
        </div>
      ))}
    </div>
  );
};

export default OfferEditing;